import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Get, Injectable, Param, Res } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { AddsEntity } from './adds.entity';
import { AddsResponseModel, AllAddsResponseModel } from './dto/adds-repose-module';
export const multerConfig = {
    dest: process.env.IMGPATHURL,
};
@Injectable()
export class AddsService {
    constructor (
        @InjectRepository(AddsEntity)
        private AddsRepository: Repository<AddsEntity>, 
       
         
    ) {}    
    

    async createAdds(queryParams, filesData, ): Promise<AddsResponseModel> {
        const response = new AddsResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const fileUpload = await this.AddsRepository.save(filesData);
                if(filesData) {
                    response.status = true;
                    response.data   = fileUpload;
                    response.statusCode = 50000;
                    response.internalMessage = 'Add saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Add not saved')
                }
            } else {
                const fileUpload = await this.AddsRepository.save(filesData);
                if(filesData) {
                    response.status = true;
                    response.data   = fileUpload;
                    response.statusCode = 50000;
                    response.internalMessage = 'Add saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Add not saved')
                }
            }            
            return response;
        } catch (error) {
            throw error;
        }
    }
	
    async getAllActiveAdds(request:Request):Promise<AllAddsResponseModel> {
        const response = new AllAddsResponseModel();
        try {
            let images: any[] = [];
            let pdfs: any[] = [];
            const data = await this.AddsRepository.find({
                where: {status: true},
                order: { createdAt: 'DESC' }
            });
			if (data.length != 0) {
				const da = data.map((file) => {
					return {
						location: file.location,
						redirectUrl: file.redirectUrl,
						imagePath: `${process.env.WORKINGURL}/${file.imagePath}`,						
                    };                   
                });
               da.map((file) => {
                    images.push({ imagePath: file.imagePath,redirectUrl:file.redirectUrl,location:file.location })
                });				
            }
            if(data) {
                response.status = true;
                response.data = images;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

}